// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes TbjRaYJI7J4xyQ {
  from {
    transform: translateX(-50%) translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}
.iad0to8ZEKQ6IW {
  position: fixed;
  z-index: 10;
  bottom: var(--ds-space-200, 16px);
  left: 50%;
  transform: translateX(-50%);
  animation: TbjRaYJI7J4xyQ 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .iad0to8ZEKQ6IW {
    animation: none;
    opacity: 1;
  }
}
.iad0to8ZEKQ6IW .ItmhnjRgS0kFcQ {
  position: relative;
  border: 0px;
}
.iad0to8ZEKQ6IW .ItmhnjRgS0kFcQ::before {
  /* stylelint-disable design-system/ensure-design-token-usage */
  background: conic-gradient(from 180deg at 50% 50%, #ffa900 -52.2deg, #0065ff 89.76deg, #0469ff 145.8deg, #bf63f3 262.8deg, #ffa900 307.8deg, #0065ff 449.76deg);
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-300, 12px);
  -webkit-mask: linear-gradient(var(--ds-background-input, #ffffff) 0 0) content-box, linear-gradient(var(--ds-background-input, #ffffff) 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
`, ""]);
// Exports
export var bulkActionLoadingIsland = `iad0to8ZEKQ6IW`;
export var slideInFromBottom = `TbjRaYJI7J4xyQ`;
export var buttonGroup = `ItmhnjRgS0kFcQ`;
export default ___CSS_LOADER_EXPORT___;
